<template>
  <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Cadastro</h6>
    </div>
    <div class="card-body">
      <div class="alert alert-warning fade show" role="alert" v-show="showAlerts">
        <div v-for="(alert, i) in alerts" v-bind:key="i">{{alert}}</div>
      </div>
      <div class="alert alert-danger fade show" role="alert" v-show="showErrors">
        <div v-for="(erro, i) in erros" v-bind:key="i">{{erro}}</div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="inicioVigencia">Inicio Vigência:</label>
            <input
              class="form-control form-control-sm"
              v-mask="'##/####'"
              id="'inicioVigencia'"
              v-model="input.dataInicioVigencia"
            />
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="fimVigencia">Fim Vigência:</label>
            <input
              class="form-control form-control-sm"
              v-mask="'##/####'"
              id="'fimVigencia'"
              v-model="input.dataFimVigencia"
            />
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="motivo">Motivo:</label>
            <select
              class="form-control form-control-sm"
              id="motivo"
              v-model="input.motivo"
              @change="getTermoResponsabilidadePorMotivo()"
            >
              <option value>Selecione</option>
              <option
                v-for="(motivo) of listaMotivoLicenca"
                v-bind:key="motivo.id"
                v-bind:value="motivo"
              >{{motivo.motivo}}</option>
            </select>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="OutroMotivoLicenca">Outro Motivo:</label>
            <input
              class="form-control form-control-sm"
              id="'OutroMotivoLicenca'"
              maxlength="250"
              v-model.trim="input.outroMotivoLicenca"
              :disabled="input.motivo == undefined || input.motivo == '' || input.motivo.outro_motivo == 0"
            />
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12" v-show="input.motivo != ''">
          <div class="form-group">
            <label
              class="col-form-label-sm label-input"
              for="valorRemuneracao">Termo de Responsabilidade:</label>
            <div>
            <button
              type="button"
              :class="input.liEaceitei ? 'btn btn-success form-control' : 'btn btn-info form-control'"
              @click="showModal()"
            >
              <li :class="input.liEaceitei ? 'oi oi-check' : 'oi oi-eye'" />
              {{btnNameLieAceito}}
            </button>
            </div>
          </div>
        </div>
      </div>
      <br />

      <br />

      <br />
            <br />
      <button class="btn btn-outline-dark" @click="limpar()">
        <li class="oi oi-ban"></li>Limpar
      </button>
      <button class="btn btn-secondary" @click="salvar()">
        <li class="oi oi-check"></li>Salvar
      </button>
    </div>
    <modal v-show="isModalVisible" @close="closeModal">
      <span slot="header">Termo de Responsabilidade</span>
      <div slot="body" v-html="input.termoResponsabilidade != undefined ? input.termoResponsabilidade.texto : ''">
        
    </div>
    <div slot="footer" class="row w-100">
        <div class="col-8">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="liAceito"
              v-model="input.liEaceitei"
            />
            <label class="custom-control-label" for="liAceito">Li e Aceito</label>
          </div>
        </div>
        <div class="col-2">
          <button class="btn btn-secondary" @click="closeModal()">
            <li class="oi oi-check"></li>Fechar
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import competencia from "../../utils/InputCompetencia";
import cnpj from "../../utils/InputCnpj";
import http from "./../../../axios";
import { CNPJ } from "cpf_cnpj";
import { mask } from "vue-the-mask";
import modal from "../../utils/Modal";
import moment from "moment"
export default {
  name: "LicencaPrevidenciariaCadastroDetalhado",
  components: { competencia: competencia, cnpj: cnpj, modal: modal },
  data() {
    return {
      input: {
        motivo: "",
        outroMotivoLicenca: "",
        cooperado: "",
        dataInicioVigencia: "",
        dataFimVigencia: "",
        liEaceitei: false,
        termoResponsabilidade : "",
        bloquearCompetenciaAtual : false
      },
      listaMotivoLicenca: [],
      listaInss: [],
      isModalVisible: false,
      carregando: false,
      showErrors: false,
      erros: [],
      showAlerts: false,
      alerts: [],
      tokens: {}
    };
  },
  directives: { mask },
  created: function() {
    this.init();
  },
  methods: {
    init: function() {
      this.getTokens();
      this.initDadosInsert();
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    }, 
    utilizaTetoInss() {
      this.input.aceitarTetoINSS = !this.input.aceitarTetoINSS;
      if (this.input.aceitarTetoINSS) {
        this.input.baseInss = this.input.valorTeto;
        this.calculaValorInss();
      } else {
        this.input.baseInss = 0;
        this.input.valorInss = 0;
      }
    },    
    getTermoResponsabilidadePorMotivo: function() {
      this.input.termoResponsabilidade = undefined;
      this.input.liEaceitei = false;
      this.input.outroMotivoLicenca = "";
      if(this.input.motivo != undefined && this.input.motivo != ''){
        http
          .get(`api/licenca/termoresponsabilidade/motivo/${this.input.motivo.id}/ultimo`, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              if(r.data.result !=  undefined && r.data.result.length > 0){
                this.input.termoResponsabilidade = r.data.result[0];
              }else{
                this.input.termoResponsabilidade = undefined;
              }
            } else {
              this.input.termoResponsabilidade = undefined;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              }
            } else if (error.request) {
              this.$router.push("/");
            } else {
              console.log("Error", error.message);
              this.$router.push("/");
            }
          });
      }else{
        this.input.termoResponsabilidade = undefined;
      }
    },
        
    initDadosInsert: function() {
        this.listaMotivoLicenca = undefined;
        this.input.termoResponsabilidade = undefined;
      http
        .get(`api/licenca/insert/dados/cooperado/${this.tokens.id}`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            if(r.data.result.listaMotivoLicenca !=  undefined && r.data.result.listaMotivoLicenca.length > 0){
              this.listaMotivoLicenca = r.data.result.listaMotivoLicenca; 
            }else{
              this.listaMotivoLicenca = undefined;
            }
          } else {
            this.listaMotivoLicenca = undefined;
            this.input.termoResponsabilidade = undefined;
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    salvar: function() {
      this.$Progress.start();
      this.salvarAntes();
      if (!this.showErrors) {
        var objeto = {
          motivo: this.input.motivo.id,
          cooperado: this.tokens.id,
          dataInicioVigencia: this.dataInicioFormatJson,
          dataFimVigencia: this.dataFimFormatJson,
          termo: this.input.termoResponsabilidade.id,
          outroMotivoLicenca: this.input.outroMotivoLicenca
        };
        http
          .post(`/api/cooperado/licenca/insert`, objeto, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.$router.push("/LicencaPrevidenciariaLista");
              this.$Progress.finish();
            }
          })
          .catch(error => {
            console.log(error);
            this.$Progress.fail();
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              } else {
                if (error.response.status == 400) {
                  for (var i in error.response.data.result) {
                    this.erros.push(error.response.data.result[i]);
                  }
                  if (this.erros.length > 0) {
                    this.showErrors = true;
                  }
                }
              }
            } else if (error.request) {
              this.$router.push("/");
            } else {
              console.log("Error", error.message);
              this.$router.push("/");
            }
          });
      } else {
        this.$Progress.fail();
      }
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },
    salvarAntes: function() {
      this.showErrors = false;
      this.erros = [];
      var dataInvalida = false;

        if (
          this.input.dataInicioVigencia == "" &&
          this.input.dataInicioVigencia.length == 0
        ) {
          this.erros.push("Inicio Vigência não informado");
          dataInvalida = true;
        } else {
          if (!this.dataValida(this.input.dataInicioVigencia)) {
            this.erros.push("Inicio Vigência inválido");
            dataInvalida = true;
          }
        }

        if (
          this.input.dataFimVigencia == "" &&
          this.input.dataFimVigencia.length == 0
        ) {
          this.erros.push("Fim Vigência não informado");
          dataInvalida = true;
        } else {
          if (!this.dataValida(this.input.dataFimVigencia)) {
            this.erros.push("Fim Vigência inválido");
          dataInvalida = true;
          }
        }
        if (!dataInvalida && moment(this.input.dataInicioVigencia, "DD/MM/YYYY", true).isAfter(moment(this.input.dataFimVigencia, "DD/MM/YYYY", true))) {
          this.erros.push("Início de Vigência maior que Fim de Vigência!")
        }

        if (
          this.input.motivo == "" &&
          this.input.motivo.length == 0
        ) {
          this.erros.push("Motivo não informado");
        }else{
            if(this.input.motivo.outro_motivo == 1 && this.input.outroMotivoLicenca == ""){
              this.erros.push("Outro Motivo não informado");
            }
            if (!this.input.liEaceitei) {
            this.erros.push(
              "Para salvar a Licença Previdenciária é necessário ler e aceitar os termos de responsabilidade"
            );
          }
        }

      this.showErrors = this.erros.length > 0;
    },
    limpar: function() {
      this.showErrors = false;
      this.erros = [];
      (this.input.motivo = ""),
        (this.input.cooperado = ""),
        (this.input.dataInicioVigencia = ""),
        (this.input.dataFimVigencia = ""),
        (this.input.termoResponsabilidade = ""),
        (this.input.liEaceitei = false);
    },
    dataValida: function(data) {
      var valido = false;
      try {
        if (data != undefined && data.length == 7) {
          const mes = data.substring(0, 2);
          const ano = data.substring(3, 7);
          if (parseInt(mes) >= 1 && parseInt(mes) <= 12) {
            if (parseInt(ano) >= 1900 && parseInt(ano) <= 2100) {
              valido = true;
            }
          }
        }
      } catch (e) {
        valido = false;
      }
      return valido;
    },
    dateFormatString: function(data) {
      try {
        const mes = data.substring(0, 2);
        const ano = data.substring(3, 7);
        const dataInicio = new Date(
          parseInt(ano),
          parseInt(mes) - 1,
          1,
          0,
          0,
          0,
          0
        );
        return ano + "-" + mes + "-01";
      } catch (e) {
        return undefined;
      }
    }
  },
  computed: {
    btnNameLieAceito: function() {
      return !this.input.liEaceitei
        ? "Ler e Aceitar Termos de Responsabilidade"
        : "Lido e aceito Termos de Responsabilidade";
    },
    btnAceitarTetoInss: function() {
      return !this.input.aceitarTetoINSS
        ? `Utilizar teto de INSS de ${Vue.filter("formatMoney")(
            this.input.valorTeto
          )}`
        : `Teto de INSS de ${Vue.filter("formatMoney")(
            this.input.valorTeto
          )} utilizado`;
    },
    cnpjSemMask: function() {
      return this.input.cnpj.replace(/[^\d]+/g, "");
    },    
    dataInicioFormatJson: function() {
      const mes = this.input.dataInicioVigencia.substring(0, 2);
      const ano = this.input.dataInicioVigencia.substring(3, 7);
      return ano + "-" + mes + "-01";
    },
    dataFimFormatJson: function() {
      const mes = this.input.dataFimVigencia.substring(0, 2);
      const ano = this.input.dataFimVigencia.substring(3, 7);
      return ano + "-" + mes + "-01";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaCadastroDetalhado.vue